export const messageDate = message =>
  [message.created_at_date, message.created_at_time].filter(Boolean).join(', ');



// WEBPACK FOOTER //
// ./app/javascript/common/components/ChatMessage/utils.js